'use client';

import { c as _c } from "react/compiler-runtime";
import { useLocalizedPath } from '@repo/i18n/hooks/use-localized-path';
import { type LinkProps, useLinkComponent } from './link-context';
export const Link = t0 => {
  const $ = _c(16);
  let href;
  let rest;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      href,
      localize: t1,
      useAnchor: t2,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = href;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
  } else {
    href = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const localize = t1 === undefined ? true : t1;
  const useAnchor = t2 === undefined ? false : t2;
  const LinkImpl = useLinkComponent();
  const localizeHref = useLocalizedPath();
  let t3;
  if ($[5] !== href || $[6] !== localize || $[7] !== localizeHref) {
    t3 = localize && typeof href === "string" ? localizeHref(href) : href;
    $[5] = href;
    $[6] = localize;
    $[7] = localizeHref;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const finalHref = t3;
  if (!LinkImpl || useAnchor) {
    let t4;
    if ($[9] !== finalHref || $[10] !== rest) {
      t4 = <a href={finalHref} {...rest} />;
      $[9] = finalHref;
      $[10] = rest;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    return t4;
  }
  let t4;
  if ($[12] !== LinkImpl || $[13] !== finalHref || $[14] !== rest) {
    t4 = <LinkImpl href={finalHref} {...rest} />;
    $[12] = LinkImpl;
    $[13] = finalHref;
    $[14] = rest;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};